import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-574a9bd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group text-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ph_mortisePrepFiles" }, "Mortise Prep Templates:", -1))
const _hoisted_3 = { class: "ph_mortise-file-list" }
const _hoisted_4 = ["onClick"]

import { ref, PropType } from 'vue'
    import usePreHangService from '@/services/pre-hang-service'
    import { MortisePrepFile } from '@/types/preHang'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MortiseFileInput',
  props: {
        fieldName: { type: String, required: true },
        files: { type: Array as PropType<MortisePrepFile[]>, required: false }
    },
  emits: ['uploadMortiseFile','removeMortiseFile'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const preHangService = usePreHangService()

    const mortiseInput = ref<HTMLInputElement | null>()
    
    async function uploadMortisePrepTemplate() {
        const fileName = await preHangService.uploadMortisePrep(mortiseInput.value as HTMLInputElement)
        const displayName = mortiseInput.value!.files![0].name
        const file = {
            fileName: fileName,
            displayName: displayName
        }
        emits('uploadMortiseFile', file, props.fieldName)
    }

    async function removeMortisePrepFile(file: MortisePrepFile) {
        emits('removeMortiseFile', file, props.fieldName)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      id: "ph_mortisePrepFiles",
      class: "form-control form-control-sm",
      type: "file",
      ref: refEl => { mortiseInput.value = refEl as HTMLInputElement },
      onChange: uploadMortisePrepTemplate
    }, null, 544),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.files, (file) => {
        return (_openBlock(), _createElementBlock("li", {
          key: file.fileName
        }, [
          _createElementVNode("p", null, _toDisplayString(file.displayName), 1),
          _createElementVNode("button", {
            class: "btn btn-sm float-end",
            onClick: ($event: any) => (removeMortisePrepFile(file))
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "trash" })
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}
}

})